import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
    environment: environment.name,
    dsn: 'https://95a9355024dc416e82b642f51b2d3e41@o4504487409876992.ingest.sentry.io/4505042508709888',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: [environment.apiUrl],
            routingInstrumentation: Sentry.routingInstrumentation,
        }),
    ],

    tracesSampleRate: 1.0,
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
